import "./Book.module.css";
import Header from "@/reusable_sections/Header";
import SecureYourChair from "./sections/SecureYourChair";
import VisitTheStudio from "./sections/VisitTheStudio";
import CommonInquiries from "./sections/CommonInquiries";
import Footer from "@/reusable_sections/Footer";
export default function BookPage() {
  return <div>
      <Header />
      <SecureYourChair />
      <VisitTheStudio />
      <CommonInquiries />
      <Footer />
    </div>;
}